import React from 'react'

const Education = () => {
  return (
    <div name = "education" className='w-full h-screen bg-gradient-to-b from-black to-gray-800 text-white'>
        <div className='max-w-screen-lg p-4 mx-auto flex-col justify-center w-full h-full grid grid-rows-1'>
            <section className=''>
                <header className='pb-10 sm:pb-20'>
                    <h1 className='text-4xl font-bold inline border-b-4 border-gray-500 '>Education</h1>
                </header>
                <div className='px-4 sm:px-8 border-l-2 border-yellow-500 lg:flex md:flex-row'>
                    <div className='border-2 bg-gray-600/[0.5] border-gray-500 cursor-pointer mb-1 sm:mb-5 transition-all hover:shadow-indigo-500/40 hover:border-transparent duration-75 md:w-1/3'>
                        <h2 className='text-2xl'>2020-2024</h2>
                        <h2 className='text-xl py-1 sm:py-2'>Sinhgad College Of Engineering, Pune</h2>
                        <h3 className='text-lg sm:pb-2 pl-2'>Current CGPA : 8.67 / 10</h3>
                        <p className=' text-lg sm:pb-2 pl-2'>I am currently pursing Bachelor's in Technology in Information Technology majors. Over the period, I have covered the CS fundamentals courses like,</p>
                        <ul className='list-disc pl-6 text-lg'>
                            <li>Data Structures & Algorithms</li>
                            <li>Database Management Systems</li>
                            <li>Operating System</li>
                            <li>Computer Networks</li>
                        </ul>
                        <p className=' text-lg pb-2 pl-2'>and have good understanding of them. I have also been part of various college societies and events.</p>
                    </div>
                    <div className='border-2 bg-gray-600/[0.5] border-gray-500 cursor-pointer mb-1 sm:mb-5 transition-all hover:shadow-indigo-500/40 hover:border-transparent duration-75 md:w-1/3'>
                        <h2 className='text-2xl sm:pb-2'>2018-2020</h2>
                        <h2 className='text-xl py-1 sm:py-2'>Navbharat Junior College, Pune</h2>
                        <ul className='flex justify-center items-center space-x-4 w-full h-12 px-4 text-lg lg:flex-none'>
                            <li><h2>HSC Board : 69.08 %</h2> </li>
                            <li><h2>MHT-CET : 89.9% tile</h2></li>
                        </ul>
                        <p className=' text-lg pb-2 pl-2'>I have completed my Higher Secondary Education in Science with Physics, Chemistry, Mathematics and Biology (PCMB).</p>
                    </div>
                    <div className='border-2 bg-gray-600/[0.5] border-gray-500 cursor-pointer  mb-1 sm:mb-5 transition-all hover:shadow-indigo-500/40 hover:border-transparent duration-75 md:w-1/3'>
                        <h2 className='text-2xl sm:pb-2'>2008-2018</h2>
                        <h2 className='text-xl py-1 sm:py-2'>Navbharat High School, Pune</h2>
                        <h1 className='pl-2 text-lg'>SSC Board : 76.60 %</h1>
                    </div>

                </div>
            </section>
        </div>
    </div>
  )
}

export default Education